import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { useLocation } from "react-router-dom";
import { EmptyList } from "../../../assets/images";
import { handleDate, formatDate } from "../../../utils/commonFunctions";
import StockLimitsHeader from "../../../components/Reports/StockLimits/StockLimitsHeader";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import { RootState } from "../../../redux/rootReducers";
import {
  getStockLimitAction,
  resetReportsError,
  resetReportsFetching,
  resetReportsSuccess,
  resetStocklimitData,
  resetStockLimitTotalCount,
} from "../../../redux/reports";
import { DownloadExcelStockLimitPayloadType, GetStockLimitPayloadType } from "../../../commonTypes/reportsTypes";
import { GetAllStocksGroupPayloadType } from "../../../commonTypes/clientSettingsTypes";
import { getAllTypesParentStockGroupAction, getAllTypesStocksGroupAction } from "../../../redux/clientSettings";
import StockLimitsTable from "../../../components/Reports/StockLimits/StockLimitsTable";
import { AllGroupStockListType } from "../../../redux/clientSettings/clientSettingTypes";
import { StockLimitReportDataType } from "../../../redux/reports/reportsType";
import FileSaver from "file-saver";
import toast from "react-hot-toast";
import { downloadStockLimitApi } from "../../../apis/reportsApis";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { STOCK_LIMIT_REPORT_TABLE_HEADERS, STOCK_LIMIT_REPORT_WITH_GRAPH_TABLE_HEADERS } from "../../../constant/tableHeadersConstants/reportsConstant/stockLimitReportConst/stockLimitReportConst";

export type DropDownItemType = {
  value: number | undefined | string;
  label: string | undefined;
};
type AppProps = {
  history: any;
  token: string | null;
  success: number | null;
  error: string | null;
  fetching: boolean;
  statusCode: number | null;
  dispatchResetSession: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchResetReportsSuccessAction: () => void;
  dispatchResetReportsFetchingAction: () => void;
  stocklimitData: [] | StockLimitReportDataType[];
  groupStockList: [] | AllGroupStockListType[];
  dispatchGetAllStockGroupsListAction: (
    data: GetAllStocksGroupPayloadType
  ) => void;
  dispatchGetStockLimitAction: (data: GetStockLimitPayloadType) => void;
  dispatchResetStocklimitData: () => void;
  stockLimitTotalCount:number;
  dispatchResetStockLimitTotalCount:()=>void;
};
const StockLimits = ({
  history,
  token,
  success,
  error,
  fetching,
  statusCode,
  dispatchResetSession,
  dispatchResetReportsErrorAction,
  dispatchResetReportsSuccessAction,
  dispatchResetReportsFetchingAction,
  stocklimitData,
  groupStockList,
  dispatchGetAllStockGroupsListAction,
  dispatchGetStockLimitAction,
  dispatchResetStocklimitData,
  stockLimitTotalCount,
  dispatchResetStockLimitTotalCount
}: AppProps) => {
  const search = useLocation().search;
  const clientCodeFromParams = new URLSearchParams(search).get("client_code");
  const companyNameFromParams = new URLSearchParams(search).get("company_name");
  const company_name = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyNameFromParams;
  const client_code = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : clientCodeFromParams;

  const [date, setDate] = useState("");
  const [toggle, setToggle] = useState<boolean>(false);
  const [stockGroupName, setStockGroupName] = useState<DropDownItemType>({
    value: "",
    label: "Select Stock Group..",
  });
  const [quantitySelected, setQuantitySelected] = useState<any>({
    value: "all",
    label: "All",
  });
  const [finalStockGroupList, setFinalStockGroupList] = useState<any>([]);
  const [isDownloadStockLimitReportPresent, setIsDownloadStockLimitReportPresent] =
    useMenuCheck();
    const [isGetLimitReportPresent, setIsGetStockLimitReportPresent] =
    useMenuCheck();

    const [currentHeaders, setCurrentHeaders] = useState(STOCK_LIMIT_REPORT_TABLE_HEADERS); 
  const [showGraph, setShowGraph] = useState(false);


  useEffect(() => {
    setIsDownloadStockLimitReportPresent("Download Stock Limit Report", "menu")
    setIsGetStockLimitReportPresent("Get Stock Limit Report", "menu")
    dispatchResetStocklimitData();
    dispatchResetReportsSuccessAction();
    dispatchResetReportsErrorAction();
    dispatchResetReportsFetchingAction();
    dispatchResetStockLimitTotalCount();
    if (client_code && token) {
      let finalData = {
        token,
        client_code,
      };

      dispatchGetAllStockGroupsListAction(finalData);
    }
  }, []);

    useEffect(() => {
      handleManipulateStockGroupListData(groupStockList);
    }, [groupStockList]);
  
    // Recussively manipulating stock group data to populate in dropdown
    const handleManipulateStockGroupListData = (
      stockGroupData: any,
      finalStockData: any = []
    ) => {
      let count = 0;
      function getAllData(arr: any) {
        arr.map((e: any, i: number) => {
          if (count > 0) {
            finalStockData.push({
              stock_group_name: e?.stock_group_name,
              stock_group_id: e?.stock_group_id,
              count,
            });
          } else {
            finalStockData.push({
              stock_group_name: e?.stock_group_name,
              stock_group_id: e?.stock_group_id,
            });
          }
          if (e.is_tree == 1) {
            count++;
            getAllData(e.tree_data);
            count--;
          }
        });
      }
  
      getAllData(stockGroupData);
      setFinalStockGroupList(finalStockData);
    };

  const handleDateChange = (date: any) => {
    const value = handleDate(date);
    setDate(value);
  };


  const handleSubmitData = () => {
    if (client_code && token) {
      const finalData = {
        token,
        client_code,
        date: formatDate(date),
     
        skuGroup: stockGroupName?.value,
        quantity:
          quantitySelected?.value === "all" ? "0" : quantitySelected?.value,
      };
      dispatchGetStockLimitAction(finalData);
    }
  };


  const handleDownload = (params: DownloadExcelStockLimitPayloadType) => {
    let reportName = company_name
    ? company_name +
      "-" +
      params?.date +
    
      ".xlsx"
    : "report";
    let finalApi =downloadStockLimitApi(params);
    finalApi.then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const  handlePrepareDownload =()=>{
    let params: DownloadExcelStockLimitPayloadType = {
      token,
      client_code,
      date: formatDate(date),
      skuGroup: stockGroupName?.value,
      quantity:
        quantitySelected?.value === "all" ? "0" : quantitySelected?.value,
    };

    if (params && token) {
      handleDownload(params);
    }
  }

  const handleChangeStatus = () => {
    setShowGraph(!showGraph);
    setCurrentHeaders(!showGraph ? STOCK_LIMIT_REPORT_WITH_GRAPH_TABLE_HEADERS : STOCK_LIMIT_REPORT_TABLE_HEADERS); 
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title="Stock Limit"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="report-card mt-4 pt-3">
        <div className="inside-report-card">
          <StockLimitsHeader
            setToggle={setToggle}
            toggle={toggle}
            date={date}
            handleDateChange={handleDateChange}
            getStockStatement={handleSubmitData}
            groupStockList={finalStockGroupList}
            stockGroupName={stockGroupName}
            setQuantitySelected={setQuantitySelected}
            quantitySelected={quantitySelected}
            stocklimitData={stocklimitData}
            handlePrepareDownload={handlePrepareDownload}
            setStockGroupName={setStockGroupName}
            isDownloadStockLimitReportPresent={isDownloadStockLimitReportPresent}
            handleChangeStatus={handleChangeStatus}
            showGraph={showGraph}
          />
                {!fetching && stocklimitData?.length ? (
                <div
                  className="sub-heading ml-3"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  stockLimitTotalCount ? stockLimitTotalCount : 0
                } entries found`}</div>
              ):""}
          {fetching ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : stocklimitData?.length > 0 ? (
            <StockLimitsTable data={stocklimitData} fetching={fetching} 
            tableHeaders={currentHeaders} 

            />
          ) : (
            <div className="mt-5 pb-5">
              {!fetching && stocklimitData?.length === 0 && (
                <EmptyListPage
                  title={`No Stock Limit Found!`}
                  text={`Choose date to get Stock Limit List.`}
                  image={EmptyList}
                  imageWidth="30%"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.reports.success,
  error: state.reports.error,
  fetching: state.reports.fetching,
  statusCode: state.reports.statusCode,
  stocklimitData: state.reports.stocklimitData,
  groupStockList: state.clientSettings.groupParentStockList,
  stockLimitTotalCount:state.reports.stockLimitTotalCount
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchResetReportsFetchingAction: () => dispatch(resetReportsFetching()),
  dispatchGetStockLimitAction: (data: GetStockLimitPayloadType) =>
    dispatch(getStockLimitAction(data)),

  dispatchGetAllStockGroupsListAction: (data: GetAllStocksGroupPayloadType) =>
    dispatch(getAllTypesParentStockGroupAction(data)),
  dispatchResetStocklimitData: () => dispatch(resetStocklimitData()),
  dispatchResetStockLimitTotalCount:()=>dispatch(resetStockLimitTotalCount())
});

export default connect(mapStateToProps, mapDispatchToProps)(StockLimits);
